export const HealthcareTabletProgram = {
    FiggersHCT: 'Figgers',
    PalmBeachHCT: 'PalmBeach',
    FloridaConnect: 'FloridaConnect',
     PompanoBeach: 'PompanoBeach'
};

export const HealthcareTabletProgramApplyFor = {
    Self: 'Self',
    Beneficiary: 'Beneficiary',
};


